import { indexItems } from '@/mocks/darkwebData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            专题索引
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            系统化暗网知识体系，按专题分类浏览全部深度内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 group hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3 text-primary-600 text-lg">
                <i className={item.icon}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {item.description}
              </p>
              <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                {item.count} →
              </span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 group hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3 text-secondary-600 text-lg">
                <i className={item.icon}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {item.description}
              </p>
              <span className="text-xs text-secondary-600 font-medium whitespace-nowrap">
                {item.count} →
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}